module.exports = __webpack_public_path__ + "img/banner.37f8f30c.png";